import React from "react";

import ManageTagsPopover, {
  ManageTagsPopoverProps,
} from "@app/analytics/components/TagPopover/ManageTagsPopover";
import useSessionTags from "@app/common/hooks/tags/useSessionTags";
import useTags from "@app/common/hooks/tags/useTags";
import type { Tag as ITag, UserMeeting } from "@app/common/types";

const EMPTY_TAGS: ITag[] = [];

const MeetingReportTagPopover = ({
  report,
  popoverProps,
}: {
  report: UserMeeting;
  popoverProps: ManageTagsPopoverProps["popoverProps"];
}) => {
  const { tags: allUserTags } = useTags();

  const { updateSessionTags } = useSessionTags({
    sessionId: report.id,
    sessionTags: report.tags ?? EMPTY_TAGS,
    context: "sessionsList",
  });

  const handleSaveTags = (updatedTags: ITag[], applyToSeries?: boolean) => {
    updateSessionTags.mutate({ updatedTags, applyToSeries });
    popoverProps?.onClose();
  };

  return (
    <ManageTagsPopover
      popoverProps={popoverProps}
      allTags={allUserTags}
      appliedTags={report.tags ?? EMPTY_TAGS}
      canApplyToSeries={Boolean(report.seriesId)}
      onSave={handleSaveTags}
    />
  );
};

export default MeetingReportTagPopover;
